export const PREVIEW_SUBDOMAINS = ["preview", "preview-dev", "preview-test", "preview-staging"] as const

export type PreviewSubdomain = (typeof PREVIEW_SUBDOMAINS)[number]

export function isPreviewSubdomain(subdomain: string): subdomain is PreviewSubdomain {
  return (PREVIEW_SUBDOMAINS as readonly string[]).includes(subdomain)
}
